















import {Component, Vue, Prop} from 'vue-property-decorator';
import {PModuleWithMeasurements, PModuleEvent} from '@/views/system/modules/interfaces';
import {pmoduleStoresByTypeMap} from '@/views/system/modules/configurate';
import {PModuleStoreModule} from '@/store/modules/entities/pmodules/interfaces';
import TableLastDBRecords from '@/components/system/developerInfo/TableLastDBRecords.vue';
import TableLastDBBoundaryRecords from '@/components/system/developerInfo/TableLastDBBoundaryRecords.vue';
import Card from '@c/Card.vue';

@Component({
  components: {TableLastDBRecords, Card, TableLastDBBoundaryRecords},
})
export default class LastDBRecordsTabDeveloperInfo extends Vue {
  // Программный модуль
  @Prop()
  pmodule!: PModuleWithMeasurements;

  // Получить хранилище
  get apiStore(): PModuleStoreModule {
    return (pmoduleStoresByTypeMap.get(this.pmodule.type) as any) as PModuleStoreModule;
  }

  error = false;
  loading = true;

  events: PModuleEvent[] = [];

  // TODO: Вынести этот код в mixin
  async mounted() {
    try {
      this.events = await this.apiStore.getEventTypes();
    } catch {
      this.error = true;
    } finally {
      this.loading = false;
    }
  }
}
